module.exports = __webpack_public_path__ + "r-v3/img/triangle.76ced0ee.svg";